const CURRENT_DATABASE_SIZE = Object.freeze({
    value: 1.4,
    unit: "PB",
    fractionDigits: 1,
});

const formatStorageSize = (size) => {
    const value = Number(size?.value || 0);
    const unit = (size?.unit || "").toUpperCase();
    const fractionDigits = Number.isInteger(size?.fractionDigits)
        ? size.fractionDigits
        : 0;

    return `${value.toLocaleString("en-US", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })} ${unit}`.trim();
};

export { CURRENT_DATABASE_SIZE, formatStorageSize };
